import queryString from 'query-string';
import { getCampaignType, campaignId, campaignStatus } from 'pages/MyAccount/utils/campaign';
import env from 'pages/MyAccount/utils/env';
import request from './request';

// eslint-disable-next-line import/prefer-default-export
export function getCampaign(campaignType) {
  const type = campaignType || getCampaignType();
  const queryParams = {
    type,
    ...(campaignId && { campaignId }),
    ...(campaignStatus && { campaignStatus }),
  };

  const requestUrl = `${env.aceApi}api/1/campaigns?${queryString.stringify(
    queryParams
  )}`;
  return request(requestUrl);
}
